import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { Icon } from 'ksnm-common-ui/lib/Icon';

import { reportingFormsStore } from '@stores/reportingFormsStore';

import styles from './Breadcrumbs.module.scss';

interface IReportingFormsBreadcrumbs {
  className?: string;
  withoutAction?: boolean;
}

export const Breadcrumbs = observer(({ className, withoutAction }: IReportingFormsBreadcrumbs) => {
  const { pagesParam, removePage, breadcrumbs, removeBreadcrumb, fullSizeInfo, setFullSizeInfo } = reportingFormsStore;

  const onClick = useCallback(
    (index) => {
      const count = breadcrumbs.length - index;

      if (count < pagesParam.length) {
        removePage(false, count);
        removeBreadcrumb(count);
      }
    },
    [breadcrumbs.length, pagesParam.length, removeBreadcrumb, removePage],
  );

  const onBack = useCallback(() => {
    removePage();
    removeBreadcrumb();
  }, [removeBreadcrumb, removePage]);

  const onClose = useCallback(() => {
    removePage(true);
    setFullSizeInfo(false);
  }, [removePage, setFullSizeInfo]);

  const onShowInfo = useCallback(() => {
    setFullSizeInfo(true);
  }, [setFullSizeInfo]);

  const onHideInfo = useCallback(() => setFullSizeInfo(false), [setFullSizeInfo]);

  return (
    <div className={cm(styles.reportingTreeBreadcrumbs, className)}>
      <div className={styles.breadcrumb}>
        {breadcrumbs.map((value, index) => {
          const isLink = breadcrumbs.length - index < pagesParam.length;

          return (
            <div
              key={value}
              onClick={() => onClick(index)}
              className={cm({
                [styles.link]: isLink,
              })}
            >
              {value}
            </div>
          );
        })}
      </div>
      {!withoutAction && (
        <div className={styles.buttons}>
          {pagesParam.length > 1 && (
            <div onClick={onBack}>
              <Icon name="cancelArrow" />
            </div>
          )}
          <div onClick={fullSizeInfo ? onHideInfo : onShowInfo}>
            <Icon name={fullSizeInfo ? 'fullScreenOpen' : 'fullScreenClose'} />
          </div>
          <div onClick={onClose}>
            <Icon name="close" fill="black" />
          </div>
        </div>
      )}
    </div>
  );
});
